import render from "services/engines/template";
import jMoment from "components/classes/Jmomen";

@autobind
export default class ReportPrint {
  /**
   * Constructing ReportPrint object
   * @param options
   */
  constructor(options) {
    this.options = options;
    this.colspan = 0;
    let tables = options.tables;
    let setting = {};
    let headers = {};
    tables.map((option, index) => {
      setting = option.setting;
      if (setting && setting.rejectedCols) {
        for (let item in setting.rejectedCols) {
          setting.rejectedCols[item] = app._.camelCase(
            setting.rejectedCols[item]
          );
        }
        //  console.log('setting.rejectedCols', setting.rejectedCols, option.tableHeader);
        for (let header in option.tableHeader) {
          if (option.tableHeader.hasOwnProperty(header)) {
            if (setting.rejectedCols.indexOf(header.toString()) < 0) {
              headers[header] = option.tableHeader[header];
            }
          }
        }
      }
      tables[index].tableHeader = headers;
    });

    this.options.tables = tables;
  }

  /**
   * Make and print configured table
   */
  print(props = {}) {
    let document = "";
    let tableHeader = "";

    document += this.renderHeader(this.options.header, props);

    if (this.options.tables && this.options.tables[0]) {
      tableHeader = this.renderTableHeader(this.options.tables[0].tableHeader);
    }

    this.options.tables.map((layout) => {
      document += this.renderTableLeader(layout.tableLeader);
      document += tableHeader;
      document += this.renderTableBody(layout.tableBody, layout.tableHeader);
      document += this.renderTableFooter(layout.tableFooter);
    });
    document += this.renderFooter(this.options.footer);

    let w = window.open();
    w.document.write(document);
    w.onload = wl(w, document.length);

    function wl(s, len = 500000) {
      let height = len / 500;

      s.setInterval(
        () => {
          s.print();
          s.close();
        },
        height < 1800 ? 180000 : height > 3000 ? 350000 : height
      );
    }

    // w.setInterval(() => {
    //   w.print();
    //   w.close();
    // }, 3500);
  }

  /**
   * Render report table leader
   * @returns {string}
   */
  renderTableLeader(leader) {
    let values = {};
    for (let property in leader) {
      if (leader.hasOwnProperty(property)) {
        values[property.toString()] = leader[property];
      }
    }
    values["colspan"] = this.colspan;
    if (values["personName"] !== "") {
      return render("report.print.table-leader-personnel", values);
    } else {
      return render("report.print.table-leader", values);
    }
  }

  /**
   * Render print page header items
   * @param header
   * @param props
   * @returns {string}
   */
  renderHeader(header, props) {
    let values = {};

    let _props = Object.assign({}, { css: "" }, props);

    for (let property in header) {
      if (header.hasOwnProperty(property)) {
        values[property.toString()] = header[property];
      }
    }
    for (let property in _props) {
      if (_props.hasOwnProperty(property)) {
        values[property.toString()] = _props[property];
      }
    }
    return render("report.print.header", values.pageTitle);
  }

  /**
   * Render print page footer and return result
   *@return {string}
   */
  renderFooter(footer) {
    return render("report.print.footer");
    // return footerTemplate.toString();
  }

  /**
   * Render report table header and return result
   * @return {string}
   */
  renderTableHeader(tableHeader) {
    let tHeader = "";
    let tHeader_ = "";
    let parent = [];
    let rowSpan;
    for (let property in tableHeader) {
      if (tableHeader.hasOwnProperty(property)) {
        if (
          tableHeader[property].props &&
          tableHeader[property].props.parent &&
          tableHeader[property].props.parent !== ""
        ) {
          if (parent[tableHeader[property].props.parent]) {
            parent[tableHeader[property].props.parent]++;
          } else {
            parent[tableHeader[property].props.parent] = 1;
          }
          this.colspan++;
          tHeader_ += `
         <th rowspan="1">${tableHeader[property].title}</th>
        `;
        }
      }
    }

    for (let property in tableHeader) {
      if (tableHeader.hasOwnProperty(property)) {
        if (
          tableHeader[property].props &&
          tableHeader[property].props.parent &&
          tableHeader[property].props.parent !== ""
        ) {
          if (parent[tableHeader[property].props.parent]) {
            tHeader += `
         <th colspan="${
           parent[tableHeader[property].props.parent]
         }" rowspan="1">${tableHeader[property].props.name}</th>
        `;
            parent[tableHeader[property].props.parent] = false;
          }
        } else {
          this.colspan++;
          tHeader += `
         <th rowspan="2">${tableHeader[property].title}</th>
        `;
        }
      }
    }
    tHeader += `</tr><tr>${tHeader_}`;

    return render("report.print.table-header", { tableHeader: tHeader });
  }

  /**
   * Render report table footer and return result
   * @return {string}
   */
  renderTableFooter(footer) {
    let values = {};
    for (let property in footer) {
      if (footer.hasOwnProperty(property)) {
        values[property.toString()] = footer[property];
      }
    }

    values["tableFooter"] = "";
    values["description"] = "";
    values["signer"] = "";
    values["colspan"] = this.colspan;

    if (values["descriptions"] && values["descriptions"] !== "") {
      values["descriptions"].map((item) => {
        values["description"] += `<div>${item}</div>`;
      });
    }

    if (values["signers"] && values["signers"] !== "") {
      values["signers"].map((item) => {
        values["signer"] += `
<div class="signer col col${values["signers"].length}">
${item.fullName ? item.fullName : ""}<br>${
          item.positionName ? item.positionName : ""
        }
</div>`;
      });

      return render("report.print.table-footer-signer", values);
    } else {
      return render("report.print.table-footer", values);
    }
  }

  /**
   * Render report table body and return result
   * @return {string}
   */
  renderTableBody(tableBody, tableHeader) {
    let tBody = "";
    let matched = false;
    let exists = false;
    tableBody.map((body, bodyIndex) => {
      let isTotal = false;
      tBody += `<tr style="color:${
        body._props && body._props.color ? body._props.color : "#000"
      }; background:${
        body._props && body._props.background ? body._props.background : "#fff"
      };">`;
      for (let headerIndex in tableHeader) {
        matched = false;
        for (let bodyItem in body) {
          isTotal =
            body._props && body._props.type && body._props.type === "footer";
          if (body.hasOwnProperty(bodyItem)) {
            if (bodyItem.toString() === headerIndex.toString()) {
              tBody += `<td style="${
                body.props && body.props[bodyItem] && body.props[bodyItem].color
                  ? `color:${body.props[bodyItem].color}`
                  : ""
              }; ${
                (body.props &&
                  body.props[bodyItem] &&
                  body.props[bodyItem].background) ||
                isTotal
                  ? `background:${
                      isTotal ? "lightgray" : body.props[bodyItem].background
                    }`
                  : ""
              };">${
                body._props &&
                body._props[bodyItem] &&
                body._props[bodyItem].before
                  ? body._props[bodyItem].before
                  : ""
              }`;
              if (
                tableHeader[bodyItem].type === "date" ||
                tableHeader[bodyItem].type === "datetime" ||
                bodyItem === "date" ||
                bodyItem === "datetime"
              ) {
                if (
                  tableHeader[bodyItem].type === "date" ||
                  bodyItem === "date"
                ) {
                  tBody += ` ${
                    body[bodyItem] !== "0000-00-00 00:00:00"
                      ? jMoment(body[bodyItem], "YYYY-M-D HH:mm:ss").format(
                          "jYYYY/jMM/jDD"
                        )
                      : "?"
                  }`;
                }
                if (
                  tableHeader[bodyItem].type === "datetime" ||
                  bodyItem === "datetime"
                ) {
                  tBody += ` ${
                    body[bodyItem] !== "0000-00-00 00:00:00"
                      ? jMoment(body[bodyItem], "YYYY-M-D HH:mm:ss").format(
                          "jYYYY/jMM/jDD"
                        )
                      : "?"
                  }`;
                }
              } else {
                tBody += ` ${app.translate(
                  `components.common.report-print.${body[bodyItem]}`,
                  `${body[bodyItem]}`
                )}`;
              }
              tBody += ` ${
                body._props &&
                body._props[bodyItem] &&
                body._props[bodyItem].after
                  ? body._props[bodyItem].after
                  : ""
              }</td>`;

              matched = true;
              break;
            }
          }
        }
        if (!matched) {
          if (isTotal) {
            tBody += `<td style="background: lightgray"> </td>`;
          } else {
            tBody += `<td> </td>`;
          }
        }
      }
      tBody += "</tr>" + "\n";
    });

    return render("report.print.table-body", { tableBody: tBody });
  }
}
